import React, { useEffect, useState } from "react";
import { Stack, Alert, Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useApp } from "../../context/AppContext";
import { useSalon } from "../../context/SalonContext";
import { useNavigate } from "react-router-dom";
import BrandedLoadingOverlay from "./BrandedLoadingOverlay/BrandedLoadingOverlay";
import { canUsePayroll } from "../../utils/payrollAccess";

export const PAYROLL_NOT_SET_UP_MESSAGE =
  "Payroll hasn't been set up for you at this location yet. Please contact your manager or owner.";

function SsoInitiate() {
  const { initiateSso } = useApp();
  const salonContext = useSalon() as any;
  const { businessInfo, currentUser } = salonContext;
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initiateSsoFlow = async () => {
      try {
        if (!businessInfo?.id || !currentUser?.id) {
          return;
        }

        // The SSO endpoint 404s without a RollFi company; don't call it.
        if (!canUsePayroll({ currentUser, businessInfo })) {
          setError(PAYROLL_NOT_SET_UP_MESSAGE);
          setIsLoading(false);
          return;
        }

        const response = await initiateSso();

        // The response is a redirect URL - navigate to it
        if (response && response.redirect_url) {
          window.location.href = response.redirect_url;
        } else {
          setError("No redirect URL received from SSO endpoint");
          setIsLoading(false);
        }
      } catch (err) {
        console.error("Error initiating SSO:", err);
        setError(
          err instanceof Error
            ? err.message
            : "Failed to initiate SSO. Please try again.",
        );
        setIsLoading(false);
      }
    };

    initiateSsoFlow();
  }, [initiateSso, currentUser, businessInfo]);

  if (error) {
    return (
      <Stack
        align="center"
        justify="center"
        style={{ minHeight: "100dvh", padding: "2rem" }}
      >
        <div style={{ maxWidth: "600px", width: "100%" }}>
          <Alert color="red" title="SSO Error" icon={<IconAlertCircle />}>
            {error}
          </Alert>
          <Button
            onClick={() => navigate("/admin/payroll")}
            color="teal"
            style={{ marginTop: "1rem" }}
            fullWidth
          >
            Return to Payroll
          </Button>
        </div>
      </Stack>
    );
  }

  return (
    <>
      <BrandedLoadingOverlay visible={isLoading} />
    </>
  );
}

export default SsoInitiate;
